import React, { Component } from "react";
import { Button, PageHeader, DropdownButton, Radio, Row, Col } from "react-bootstrap";
import KeywordsInput              from "../../components/exercise/KeywordsInput";
import DropdownExerciseCategories from "../../components/exercise/DropdownExerciseCategories";
import ExerciseCategories         from "../../utils/ExerciseCategories";
import LoaderButton               from "../../components/LoaderButton";
import FooterLoadingBar           from "../../components/utils/FooterLoadingBar";
import RenderLander               from "../../components/utils/RenderLander";
import { Colors }                 from "../../utils/Colors";
import { AdminIdTS, AdminIdASP }                 from "../../utils/StaticIds";
import ModalAlert                 from "../../components/modal/ModalAlert";
import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import uniqueId                     from 'lodash/uniqueId';
import YouTubePlayer                from "../../components/YouTubePlayer";
import TextAreaMod                  from "../../components/TextAreaMod";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";
import { createHTMLMarkup }         from "../../utils/HTML";
import { invokeAddExercise,
         invokeGetExerciseDetail,
         invokeSetDuplicateExercise } from "../../utils/AwsInvoke";
import "../../css/exercise/ExerciseNew.css";

const BULLET = '\u2022 ';
const RETURN = '\n';
const CHAR_COUNT = 1500;
const START_TEXT   = BULLET+"Describe the starting position";
const EXECUTE_TEXT = BULLET+"Provide clear and concise instructions on how to perform each step of the exercise";
const FOCUS_TEXT   = BULLET+"Detail what the trainee should concentrate on for safety and best practice";
const GOAL_TEXT    = BULLET+"What is the objective of the exercise?\n  Eg. Core, strength, thoracic mobility, quad strength, etc...";
//WhiteLabel();
//const CAT_JSON = "http://ec2-52-70-196-253.compute-1.amazonaws.com/json/tree_exercise_data.json";
//var jsonData = require('../exerciseCategories.json');

export default class ExerciseNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
          exercise_id: `${this.props.match.params.id}`,
          programs: [],
          exercise_name: "",
          category_id: 0,
          category_name: "",
          video_link: "",
          keywords:   [],
          publish: 0,
          startTextLgth: 0,
          start:    "",
          executeTextLgth: 0,
          execute:  "",
          focusTextLgth: 0,
          focus:    "",
          goalTextLgth: 0,
          goal:     "",
          loadingData: "",
          showLoadingBar: "none",

          modalAlertTitleText: "",
          modalAlertBodyText:  "",
          showModalAlert:      false, // true | false
          alertObject:         {},
          alertAction:         "",
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            var exercise_id = this.state.exercise_id;
            if(this.state.exercise_id != undefined) {
                this.getExerciseDetail(exercise_id);
            }
        } catch (e) {
            alert(e);
        }
    }

    /*componentWillUnmount () {
        console.log("2. this.props.history.action: " + this.props.history.action);

        if (this.props.history.action === "POP") {
            console.log("**************");
            this.setState({ history: 0})
            this.props.history.go(1);
            //this.onBackButtonEvent();
            //this.props.history.goForward()
            //this.props.history.goBack();
        }
    }*/

    splitKeywords = (keywords) => {
        var k_arr = [];
        for (var k = 0; k < keywords.length; k++) {
            var keyword = keywords[k].keyword;
            k_arr.push(keyword);
        }

        return k_arr;
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: ""
        })
    }

    getExerciseDetail = async (exercise_id) => {

        if(exercise_id != "undefined") {
                this.setState({
                    loadingData: "Loading exercise data ... "
                })
                const results = await invokeGetExerciseDetail(exercise_id);
                var keywords  = results.data.keywords;

                if(results) {
                    var data    = results.data.exercise_data[0];
                    var publish = data.publish;
                    var name    = data.name;
                    var start   = data.start;
                    var execute = data.execute;
                    var focus   = data.focus;
                    var goal    = data.goal;
                    var youtube = data.youtube_id;
                    var keywords    = this.splitKeywords(keywords);
                    var category_id = data.cat_id;
                    var company_id  = data.company_id;
                    var category_name = ExerciseCategories(category_id);

                    if(youtube === null) youtube = "";

                    ////  Replace \r\n with <br/>  ////
                    if(start != null) start   = start.replace(/(?:\\[rn])+/g, "<br/>");
                    if(execute != null) execute = execute.replace(/(?:\\[rn])+/g, "<br/>");
                    if(focus != null) focus   = focus.replace(/(?:\\[rn])+/g, "<br/>");
                    if(goal != null) goal    = goal.replace(/(?:\\[rn])+/g, "<br/>");

                    this.setState({
                        publish: publish,
                        exercise_name: name,
                        start:   start,
                        execute: execute,
                        focus:   focus,
                        goal:    goal,
                        video_link: youtube,
                        category_id: category_id,
                        company_id:    company_id,
                        category_name: category_name,
                        keywords: keywords,
                        isLoading: false
                    });
                    this.msgDataLoaded();
                } else
                    this.msgDataLoaded();
        }
    }

    /*********************************************************/

    handleProgramClick = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    getExerciseCategory = (id, category) => {
        //console.log("ex cat id: "+id);
        //console.log("category: "+category);
        this.setState({ category_id: id, category_name: category })
    }
    /*********************************************************/
    /****************** Textfield Handlers *******************/

    handleSubmit = async event => {
        event.preventDefault();
        var exercise_name = this.state.exercise_name;
        var exercise_id   = this.state.exercise_id;
        var video_link    = this.state.video_link;
        var start         = "";
        var execute       = "";
        var focus         = "";
        var goal          = "";
        var publish       = this.state.publish;
        var category_id   = parseInt(this.state.category_id);
        var keywords      = this.state.keywords;

        start   = this.state.start;
        execute = this.state.execute;
        focus   = this.state.focus;
        goal    = this.state.goal;

        if(exercise_id == "undefined") exercise_id = "new";

        if(exercise_name === "") {
            var body_text  = "An exercise name is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
        } else {
            this.setState({ isLoading: true, showLoadingBar: "inline" });
            try {
                const results = await invokeAddExercise(exercise_id, publish, exercise_name, start, execute, focus, goal, video_link, category_id, keywords);

                if(results.status === true) {
                    this.setState({
                        isLoading: false,
                        showLoadingBar: "none"
                    });
                    this.goToExerciselist();
                } else {
                    var body_text  = "Sorry, we had problems adding the exercise. Please try again";
                    this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                    this.setState({ isLoading: false, showLoadingBar: "none" });
                }

            } catch (e) {
                var body_text  = "Sorry, there's an error: " + e;
                this.setModalAlertProps("Error", body_text, true); // title_text, body_text, show_modal
                this.setState({ isLoading: false, showLoadingBar: "none" });
            }
        }
    }

    cancelExercise = () => {
        this.goToExerciselist();
    }

    goToExerciselist = () => {
        this.props.history.goBack();
        // this.props.history.push("/exercise/listAll/&");
    }

    handleNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            exercise_name: text
        });
    }

    handleVideoLinkChange  = (event) => {
        var text = event.target.value;
        var newval = '';

        if (newval = text.match(/(\?|&)v=([^&#]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\.be\/)+([^\/]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\embed\/)+([^\/]+)/)) {
            text = newval.pop().replace('?rel=0','');
        }

        this.setState({
            video_link: text
        });
    }

    getKeywords = (keywords) => {
        this.setState({
            keywords: keywords
        })
    }

    handleStartChange = (text) => {
        if(text.length < CHAR_COUNT+1) {
            this.setState({ start: text, startTextLgth: text.length});
        }
    }

    handleExecuteChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ execute: text, executeTextLgth: text.length});
    }

    handleFocusChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ focus: text, focusTextLgth: text.length});
    }

    handleGoalChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ goal: text, goalTextLgth: text.length});
    }

    handlePublish = (event) => {
        this.setState({
            publish: event.target.value
        })
    }

    async handleDupeExercise () {
        var exercise_id = this.state.exercise_id;

        this.setState({
            loadingData: "Duplicating exercise..."
        })


        var results = await invokeSetDuplicateExercise(exercise_id);

        if(results.status === true) {
            this.setState({
                isLoading: false,
                showLoadingBar: "none",
                loadingData: ""
            }, function(){
                this.props.history.goBack();
            });

        } else {

        }
    }

    renderHome() {
        var publishNo = false;
        var publishYes = false;
        var title      = "Exercise Detail";
        var editPage   = false;
        var disable_tf = true;
        var is_exercise_owner = false;
        var border_style = 0;
        var category_label = "";
        var hide_div       = "none";
        var exercise_id    = this.state.exercise_id;
        var owner_company_id     = this.state.company_id;
        var current_company_id   = this.props.globalCompanyId;

        var youtube_component = <YouTubePlayer yt_id={this.state.video_link} />
        var start_component   = <div style={{textAlign: "left", padding: 10}} dangerouslySetInnerHTML={createHTMLMarkup( this.state.start )} />
        var execute_component = <div style={{textAlign: "left", padding: 10}} dangerouslySetInnerHTML={createHTMLMarkup( this.state.execute )} />
        var focus_component   = <div style={{textAlign: "left", padding: 10}} dangerouslySetInnerHTML={createHTMLMarkup( this.state.focus )} />
        var goal_component    = <div style={{textAlign: "left", padding: 10}} dangerouslySetInnerHTML={createHTMLMarkup( this.state.goal )} />

        if(owner_company_id === current_company_id) is_exercise_owner = true;


        ////  If no value is available, do not show component otherwise it takes up vertical space  ////
        var video_link_value = this.state.video_link;
        var start_value      = this.state.start;
        var execute_value    = this.state.execute;
        var focus_value      = this.state.focus;
        var goal_value       = this.state.goal;

        if(video_link_value === "") youtube_component = "None.";
        if(start_value === "")      start_component   = "None.";
        if(execute_value === "")    execute_component = "None.";
        if(focus_value === "")      focus_component   = "None.";
        if(goal_value === "")       goal_component    = "None.";

        ////  LET OWNER BE ABLE TO EDIT EXERCISE  ////
        ////  (exercise_id == "undefined" means the exercise is NEW  ////
        ////  If exercise is NEW, anyone can add an exercise         ////
        if(exercise_id == "undefined" || is_exercise_owner || current_company_id == AdminIdASP || current_company_id == AdminIdTS) {
            title      = "Add/Edit an Exercise";
            editPage   = true;
            disable_tf = false; // lets admins edit tfs
            border_style = "";
            category_label = "Assign a Category";
            hide_div       = "";

            youtube_component = <input type        = "text"
                                       placeholder = "YouTube Link"
                                       value       = {video_link_value}
                                       onChange    = {this.handleVideoLinkChange.bind(this)}
                                       className   = "input-lg tf_addExercise" />
            start_component   = <TextAreaMod placeholder  = {START_TEXT}
                                     value        = {start_value}
                                     handleChange = {this.handleStartChange.bind(this)}
                                />
            execute_component = <TextAreaMod placeholder  = {EXECUTE_TEXT}
                                     value        = {this.state.execute}
                                     handleChange = {this.handleExecuteChange.bind(this)}
                                />
            focus_component   = <TextAreaMod placeholder  = {FOCUS_TEXT}
                                     value        = {this.state.focus}
                                     handleChange = {this.handleFocusChange.bind(this)}
                                />
            goal_component    = <TextAreaMod placeholder  = {GOAL_TEXT}
                                      value        = {this.state.goal}
                                      handleChange = {this.handleGoalChange.bind(this)}
                                 />
        }/* */

        if(this.state.publish == "Yes" || this.state.publish === 1 )
            publishYes = true;
        else
            publishNo = true;


        return (


          <div className="programs">
            <PageHeader>
                    <span style={{width:"220px", position:"relative", top:6}}>
                        <span className="glyphicon glyphicon-user" style={{ position:"relative", top:2, fontSize: '.9em', color: Colors.primary_color, paddingRight:"16px" }}/>
                        { title }
                    </span>
                    <span className="pull-right" style={{ position:"relative", top: -3, right: 12}}>
                        <Button className = "btnClientAddNew"
                                style     = {{ position:"relative", top:0}}
                                onClick   = {this.handleDupeExercise.bind(this)}>
                            Duplicate Exercise
                        </Button>
                    </span>

                    <div style={{textAlign:"center", fontSize:"16px", color: "red"}}><br/>{ this.state.loadingData }</div>

            </PageHeader>

            <form onSubmit={this.handleSubmit} className="form" style={{fontSize: 20}}>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                  Exercise Name
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span>
                                  <input type="text"
                                         disabled    = {disable_tf}
                                         style       = {{border: border_style, fontSize: 20}}
                                         placeholder = "Exercise Name"
                                         value       = {this.state.exercise_name}
                                         onChange    = {this.handleNameChange.bind(this)}
                                         className   = "input-lg tf_addExercise" />
                              </span>
                          </Col>
                    </Row>

                    <div className="iconAddExerciseVertSpacer" ></div>
                    <Row className="grid">
                          <Col xs={6} sm={6} md={6}>
                              <span className="formLabel">
                                  YouTube Video Link
                              </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                              <span className="formLabel">
                                  { category_label }
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={6} sm={6} md={6}>
                              <span style={{textDecoration: "none", display:"inline-block", width: "100%", textAlign: "left"}}>
                                      { youtube_component }
                              </span>
                          </Col>

                          <Col xs={6} sm={6} md={6}>
                              <span className="formLabel" style={{display: hide_div}}>
                                  <DropdownExerciseCategories
                                      id        = {this.state.category_id}
                                      category  = {this.state.category_name}
                                      getExerciseCategory={this.getExerciseCategory}
                                  />
                              </span>
                          </Col>
                    </Row>
                    { /********* KEYWORDS *********/ }
                    <div className="iconAddExerciseVertSpacer" style={{display: hide_div}}></div>
                    <Row className="grid" style={{display: hide_div}}>
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                     Keywords <span className="labelSizeSm">(press return key after every word)</span>
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid" style={{display: hide_div}}>
                          <Col xs={12} sm={12} md={12}>
                              <span>
                                    <KeywordsInput
                                        tags        = {this.state.keywords}
                                        disabled    = {disable_tf}
                                        style       = {{border: border_style}}
                                        getKeywords ={this.getKeywords}
                                    />
                              </span>
                          </Col>
                    </Row>
                    { /********* START *********/ }
                    <div className="iconAddExerciseVertSpacer"></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                    1. Start
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span style={{textDecoration: "none", display:"inline-block", width: "100%", textAlign: "left"}}>
                                  { start_component }
                              </span>
                              <span style = {{display: hide_div}}>
                                  <br/><br/>
                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.startTextLgth}</span>
                              </span>
                          </Col>
                    </Row>

                    <div className="iconAddExerciseVertSpacer" style = {{display: hide_div}}></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                    2. Execute
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span style={{textDecoration: "none", display:"inline-block", width: "100%", textAlign: "left"}}>
                                    { execute_component }
                              </span>
                              <span style = {{display: hide_div}}>
                                  <br/><br/>
                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.executeTextLgth}</span>
                              </span>
                          </Col>
                    </Row>

                    <div className="iconAddExerciseVertSpacer" style = {{display: hide_div}}></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                    3. Focus
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span style={{textDecoration: "none", display:"inline-block", width: "100%", textAlign: "left"}}>
                                  { focus_component }
                              </span>
                              <span style = {{display: hide_div}}>
                                  <br/><br/>
                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.focusTextLgth}</span>
                              </span>
                          </Col>
                    </Row>

                    <div className="iconAddExerciseVertSpacer" style = {{display: hide_div}}></div>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">
                                    4. Goal
                              </span>
                          </Col>
                    </Row>
                    <Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span style={{textDecoration: "none", display:"inline-block", width: "100%", textAlign: "left"}}>
                                  { goal_component }
                              </span>
                              <span style = {{display: hide_div}}>
                                  <br/><br/>
                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.goalTextLgth}</span>
                              </span>
                          </Col>
                    </Row>

                    <div className="iconAddExerciseVertSpacer"></div>
                {/*}<Row className="grid">
                          <Col xs={12} sm={12} md={12}>
                              <span className="formLabel">

                                        Publish: <br/>
                                          <Radio name="radioGroup"
                                                 inline
                                                 checked={publishNo}
                                                 value = "No"
                                                 onChange = {this.handlePublish.bind(this)}>
                                                 No
                                          </Radio>{' '}
                                          <Radio name="radioGroup"
                                                 inline
                                                 checked={publishYes}
                                                 value = "Yes"
                                                 onChange = {this.handlePublish.bind(this)}>
                                            Yes
                                          </Radio>

                              </span>
                          </Col>
                    </Row>
                    <div className="iconAddExerciseVertSpacer"></div>*/ }

                <Row className="grid" style = {{display: hide_div}}>
                      <Col xs={6} sm={6} md={6}>
                          <span onClick = { () => this.cancelExercise()}>
                              <LoaderButton
                                block
                                type    = "button"
                                text    = "Cancel"
                                style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                              />
                          </span>
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                              <LoaderButton
                                block
                                style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                //disabled={!this.validateForm()}
                                isLoading={this.state.isLoading}
                                text    = "Submit"
                                type    = "submit"
                                loadingText="Logging in…"
                              />
                        </Col>
                    </Row>
            </form>
            <br/><br/><br/><br/><br/>
          </div>
        );
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    render() {
        let closeModalAlert = () => this.setState({ showModalAlert: false }); //close alert modal window

        return (
              <div className="Home">
                  {this.props.isAuthenticated ? this.renderHome() : <RenderLander />}

                  <FooterLoadingBar text={"Saving Exercise Data..."}
                                    showLoadingBar={this.state.showLoadingBar} />

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/exercise/ExerciseNew.js